"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Registration = undefined;

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require("react-redux");

var _auth = require("../../redux/modules/auth");

var _license = require("../../redux/modules/license");

var _reduxForm = require("redux-form");

var _registrationValidator = require("./registrationValidator");

var _registrationValidator2 = _interopRequireDefault(_registrationValidator);

var _reactHelmet = require("react-helmet");

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _RegistrationForm = require("../../components/registration/RegistrationForm");

var _RegistrationForm2 = _interopRequireDefault(_RegistrationForm);

var _reactRouterRedux = require("react-router-redux");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Registration = exports.Registration = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(Registration, _Component);

  function Registration(props) {
    (0, _classCallCheck3.default)(this, Registration);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Registration.__proto__ || (0, _getPrototypeOf2.default)(Registration)).call(this, props));

    _this.state = {
      hasDriverLicenseAvailable: false
    };
    return _this;
  }

  (0, _createClass3.default)(Registration, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {

      if (this.props.auth.registrationSuccess && !this.props.auth.user) {
        this.props.pushRoute("/autologin");
      }

      if (this.props.license.availableTokens) {
        if (this.props.license.availableTokens > 0) {
          if (this.state.hasDriverLicenseAvailable == false) {
            this.setState({ hasDriverLicenseAvailable: true });
          }
        }
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var driverLicenseToken = this.props.params.driverLicenseToken;


      if (driverLicenseToken) {
        this.props.checkDriverLicenseCount(driverLicenseToken);
        this.props.dispatch((0, _reduxForm.change)("register", "driver_license_token", driverLicenseToken));
      }

      if (this.props.auth.registrationSuccess && !this.props.auth.user) {
        return _react2.default.createElement(
          "div",
          { className: "container" },
          _react2.default.createElement(_reactHelmet2.default, { title: "Rekister\xF6idy step 2" }),
          "here we go"
        );
      }
    }
  }, {
    key: "render",
    value: function render() {
      var driverLicenseToken = this.props.params.driverLicenseToken;


      return _react2.default.createElement(
        "div",
        { className: "container" },
        _react2.default.createElement(_reactHelmet2.default, { title: "Rekister\xF6idy" }),
        _react2.default.createElement(_RegistrationForm2.default, {
          driverLicenseToken: driverLicenseToken,
          hasDriverLicenseAvailable: this.state.hasDriverLicenseAvailable,
          fields: this.props.fields,
          handleSubmit: this.props.handleSubmit,
          register: this.props.register,
          auth: this.props.auth
        })
      );
    }
  }]);
  return Registration;
}(_react.Component), _class.propTypes = {
  fields: _react.PropTypes.object.isRequired,
  handleSubmit: _react.PropTypes.func.isRequired,
  register: _react.PropTypes.func.isRequired,
  resetRegister: _react.PropTypes.func.isRequired,
  pushRoute: _react.PropTypes.func.isRequired,
  auth: _react.PropTypes.object.isRequired,
  license: _react.PropTypes.object.isRequired,
  params: _react.PropTypes.object
}, _temp);
exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    auth: state.auth,
    license: state.license
  };
}, {
  register: _auth.register,
  resetRegister: _auth.resetRegister,
  checkDriverLicenseCount: _license.checkDriverLicenseCount,
  pushRoute: _reactRouterRedux.push
})((0, _reduxForm.reduxForm)({
  form: "register",
  initialValues: {

    profile: "DRIVERPROFILE"
  },
  fields: ["profile", "email", "first_name", "last_name", "phone", "password", "password2", "send_transfer_requests", "tos_accepted", "address", "postal_code", "postal_area", "business_id", "company_name", "company_address", "company_postal_code", "company_postal_area", "order_reference", "driver_license_token"],
  validate: _registrationValidator2.default
})(Registration));


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/Registration/Registration.js
 ** module id = 1240
 ** module chunks = 0
 **/